import { render, staticRenderFns } from "./TheBreakMenu.vue?vue&type=template&id=7a31dd0c&scoped=true"
import script from "./TheBreakMenu.vue?vue&type=script&lang=js"
export * from "./TheBreakMenu.vue?vue&type=script&lang=js"
import style0 from "./TheBreakMenu.vue?vue&type=style&index=0&id=7a31dd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31dd0c",
  null
  
)

export default component.exports